var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":"date-picker"}},[_c('EditPoint',_vm._b({},'EditPoint',_vm.dataProp,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }